import { render } from "./AdPopUpSmall.vue?vue&type=template&id=b97c7eaa&scoped=true"
import script from "./AdPopUpSmall.vue?vue&type=script&lang=js"
export * from "./AdPopUpSmall.vue?vue&type=script&lang=js"

import "./AdPopUpSmall.vue?vue&type=style&index=0&id=b97c7eaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97c7eaa"]])

export default __exports__